import { combineReducers } from 'redux';
import {
    REQUEST_COUNTERS,
    RECEIVE_COUNTERS,
    RECEIVE_1PAGE_COUNTERS,
    RECEIVE_SINGLE_COUNTER,
    CREATE_COUNTER,
    COUNTERS_PAGE_COUNT, FINISH_COUNTERS_FETCHING,
} from "./actions";
import {CREATE_EVENT} from "../Events/actions";

const isCountersFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COUNTERS:
            return true;
        case RECEIVE_COUNTERS:
        case RECEIVE_1PAGE_COUNTERS:
        case RECEIVE_SINGLE_COUNTER:
        case FINISH_COUNTERS_FETCHING:
            return false;
        default:
            return state;
    }
};

const items = (state = [], action) => {
    switch (action.type) {
        case REQUEST_COUNTERS:
            return state;
        case RECEIVE_COUNTERS:
            if (Array.isArray(action.counters)) {
                const newState = [...state];
                action.counters.forEach(counter => {
                    if (!newState.some(item => item.id === counter.id)) {
                        newState.push(counter);
                    }
                });
                return newState;
            }
            return state;
        case RECEIVE_1PAGE_COUNTERS:
            return action.counters;
        case CREATE_COUNTER:
            return [action.counter, ...state];
        default:
            return state;
    }
};

const singleCounter = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_SINGLE_COUNTER:
            return action.payload;
        default:
            return state;
    }
};

const hasMore = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COUNTERS:
            return true;
        case RECEIVE_COUNTERS:
        case RECEIVE_1PAGE_COUNTERS:
            return action.counters.length >= COUNTERS_PAGE_COUNT;
        default:
            return state;
    }
};

export const getCounters = (state) => state.items;
export const getSingleCounter = (state) => state.singleCounter;
export const getCountersFetching = (state) => state.isCountersFetching;
export const getCountersHasMore = (state) => state.hasMore;

const counters = combineReducers({
    items,
    singleCounter,
    isCountersFetching,
    hasMore,
});

export default counters;